module.exports = __webpack_public_path__ + "static/media/pot.cb30fab2.jpg";